<template>
  <v-container
    id="logout-view"
    class="fill-height"
    tag="section"
  />
</template>
<script>
  import { call } from 'vuex-pathify'
  export default {
    name: 'Logout',
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.logout()
        return false
      })
    },
    methods: {
      logout: call('auth/logout'),
    },
  }
</script>
